import { render, staticRenderFns } from "./settingToolbar.vue?vue&type=template&id=654be014&scoped=true&"
import script from "./settingToolbar.vue?vue&type=script&lang=js&"
export * from "./settingToolbar.vue?vue&type=script&lang=js&"
import style0 from "./settingToolbar.vue?vue&type=style&index=0&id=654be014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654be014",
  null
  
)

export default component.exports